module.exports = __webpack_public_path__ + "img/alert-cat.331e2878.png";